import { create } from "zustand";
import axios from "../lib/axios";

export interface Tenant {
  id: string;
  name: string;
  slug: string;
  _count?: {
    users: number;
    events: number;
  };
}

interface TenantStore {
  selectedTenantId: string | null;
  tenants: Tenant[];
  isLoadingTenants: boolean;
  setSelectedTenantId: (tenantId: string | null) => void;
  fetchTenants: () => Promise<void>;
}

const useTenantStore = create<TenantStore>((set, get) => ({
  selectedTenantId: localStorage.getItem("selected_tenant_id"),
  tenants: [],
  isLoadingTenants: false,

  setSelectedTenantId: (tenantId) => {
    if (tenantId) {
      localStorage.setItem("selected_tenant_id", tenantId);
    } else {
      localStorage.removeItem("selected_tenant_id");
    }
    set({ selectedTenantId: tenantId });
  },

  fetchTenants: async () => {
    set({ isLoadingTenants: true });
    try {
      const { data } = await axios.get("/platform/tenants");
      const tenants = data.data || [];
      set({ tenants, isLoadingTenants: false });

      // Auto-select first tenant if none selected
      const current = get().selectedTenantId;
      if (!current && tenants.length > 0) {
        get().setSelectedTenantId(tenants[0].id);
      }
    } catch (error) {
      console.error("Failed to fetch tenants:", error);
      set({ isLoadingTenants: false });
    }
  },
}));

export const useTenant = () => useTenantStore();
